import { server } from "../../server";
import { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const VENDOR_API =
  "https://q1xgsyocc2.execute-api.ap-south-1.amazonaws.com/Prod/vendors";

function ContractsRenewals() {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const MySwal = withReactContent(Swal);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const recordsPerPage = 10;
  const today = new Date().toISOString().split("T")[0];
  const [isEditing, setIsEditing] = useState(false);
  const [editVendorId, setEditVendorId] = useState(null);
  const [editVendorData, setEditVendorData] = useState(null);
  const [contracts, setContracts] = useState([
    { contractTitle: "", contractType: "", contractValue: "" },
  ]);

  const fetchVendors = async () => {
    setLoading(true);
    try {
      const response = await axios.get(VENDOR_API, {
        headers: { Authorization: `${localStorage.getItem("token")}` },
      });
      const data =
        response.data?.body?.data || response.data?.data || response.data || [];
      setVendors(Array.isArray(data) ? data : []);
    } catch (error) {
      toast.error("Failed to fetch vendors", { position: "top-right" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVendors();
  }, []);

  const handleEditClick = (vendor) => {
    setEditVendorData(vendor);
    setEditVendorId(vendor.vendorId);
    setContracts(
      vendor.contracts?.length
        ? vendor.contracts
        : [{ contractTitle: "", contractType: "", contractValue: "" }],
    );
    setIsEditing(true);
    const modal = new window.bootstrap.Modal(
      document.querySelector(".contract-modal"),
    );
    modal.show();
  };

  const handleContractChange = (index, e) => {
    const { name, value } = e.target;
    setContracts((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [name]: value };
      return updated;
    });
  };

  const addContract = () =>
    setContracts((prev) => [
      ...prev,
      { contractTitle: "", contractType: "", contractValue: "" },
    ]);
  const removeContract = (index) =>
    setContracts((prev) => prev.filter((_, i) => i !== index));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.put(
        VENDOR_API,
        { ...editVendorData, vendorId: editVendorId, contracts },
        {
          headers: { Authorization: `${localStorage.getItem("token")}` },
        },
      );
      toast.success("Contracts Updated", { position: "top-right" });
      document.querySelector('[data-bs-dismiss="modal"]')?.click();
      fetchVendors();
    } catch (error) {
      toast.error("Please Try Again", { position: "top-right" });
    } finally {
      setLoading(false);
    }
  };

  const filteredRecords = vendors.filter((vendor) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      vendor.vendorName?.toLowerCase().includes(searchLower) ||
      vendor.vendorType?.toLowerCase().includes(searchLower) ||
      vendor.contracts?.some((c) =>
        c.contractTitle?.toLowerCase().includes(searchLower),
      )
    );
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const totalPages = Math.ceil(filteredRecords.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredRecords.slice(
    indexOfFirstRecord,
    indexOfLastRecord,
  );

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };
  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleExportExcel = () => {
    if (!vendors.length) {
      toast.error("No data to export");
      return;
    }
    const sheetData = [];
    vendors.forEach((v) => {
      if (v.contracts?.length) {
        v.contracts.forEach((c) => {
          sheetData.push({
            "Vendor Name": v.vendorName || "",
            "Vendor Type": v.vendorType || "",
            "Contact Person": v.contactPerson || "",
            "Contract Title": c.contractTitle || "",
            "Contract Type": c.contractType || "",
            "Contract Value": c.contractValue || "",
          });
        });
      } else {
        sheetData.push({
          "Vendor Name": v.vendorName || "",
          "Vendor Type": v.vendorType || "",
          "Contact Person": v.contactPerson || "",
          "Contract Title": "",
          "Contract Type": "",
          "Contract Value": "",
        });
      }
    });
    const worksheet = XLSX.utils.json_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Contracts");
    XLSX.writeFile(workbook, `Contracts_${today}.xlsx`);
    toast.success("Report Generated");
  };

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div
            className="modal fade contract-modal"
            tabIndex="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <form onSubmit={handleSubmit}>
                  <div className="modal-header d-flex justify-content-between">
                    <h5 className="modal-title fs-4">Update Contracts</h5>
                    <div className="d-flex align-items-center">
                      <span className="badge bg-success-soft me-3 px-3">
                        Editable
                      </span>
                      <div className="form-check form-switch me-4">
                        <input
                          type="checkbox"
                          className="form-check-input m-0"
                          checked
                          readOnly
                        />
                      </div>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                  </div>
                  <div className="modal-body">
                    <div className="px-3 py-2 bg-light rounded-4 mb-3">
                      <p className="m-0 text-dark fw-medium">
                        {editVendorData?.vendorName} &mdash;{" "}
                        <span className="text-secondary fw-normal">
                          {editVendorData?.vendorType}
                        </span>
                      </p>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <p className="m-0 fw-medium text-dark">Contracts</p>
                      <span
                        onClick={addContract}
                        className="badge bg-success-soft cursor-pointer px-3"
                      >
                        + Add Contract
                      </span>
                    </div>
                    {contracts.map((contract, index) => (
                      <div key={index} className="row g-2 mb-2">
                        <div className="col-lg-4 col-12">
                          <label className="form-label mb-1 ms-3">
                            Contract Title
                          </label>
                          <input
                            type="text"
                            className="form-control text-dark"
                            name="contractTitle"
                            value={contract.contractTitle}
                            onChange={(e) => handleContractChange(index, e)}
                            placeholder="Annual Supply"
                          />
                        </div>
                        <div className="col-lg-4 col-12">
                          <label className="form-label mb-1 ms-3">
                            Contract Type
                          </label>
                          <input
                            type="text"
                            className="form-control text-dark"
                            name="contractType"
                            value={contract.contractType}
                            onChange={(e) => handleContractChange(index, e)}
                            placeholder="Yearly"
                          />
                        </div>
                        <div className="col-lg-4 col-12">
                          <label className="form-label mb-1 ms-3">
                            Value (₹)
                          </label>
                          <input
                            type="text"
                            className="form-control text-dark"
                            name="contractValue"
                            value={contract.contractValue}
                            onChange={(e) => handleContractChange(index, e)}
                            placeholder="500000"
                          />
                        </div>
                        <div className="col-lg-2 col-12 d-flex align-items-end pb-1">
                          {contracts.length > 1 && (
                            <span
                              onClick={() => removeContract(index)}
                              className="badge bg-danger-soft cursor-pointer px-3"
                            >
                              Remove
                            </span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="modal-footer d-flex justify-content-between py-2">
                    <div>
                      <button
                        type="button"
                        className="btn btn-secondary px-3 me-1 rounded-pill"
                        data-bs-dismiss="modal"
                      >
                        <i className="bi bi-x-lg"></i>
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary px-5 rounded-pill fw-normal"
                        disabled={loading}
                      >
                        {loading ? (
                          <div
                            className="spinner-border spinner-border-sm"
                            role="status"
                          ></div>
                        ) : (
                          "Update"
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="">
            <div className="container-fluid my-3 px-3">
              <div className="row g-2">
                <div className="col-lg-8">
                  <div className="table-responsive border-0 overflow-y-hidden bg-white rounded-4">
                    <table className="table mb-0 text-nowrap table-centered">
                      <thead className="table-light">
                        <tr>
                          <th className="w-10">No.</th>
                          <th className="lh-1 w-60">
                            Details
                            <i className="bi bi-info-circle ms-2 text-dark"></i>
                            <br />
                            <span className="fs-8 fw-normal text-secondary">
                              Displaying Information as per Record
                            </span>
                          </th>
                          <th className="lh-1 w-30">
                            Action
                            <i className="bi bi-person-gear ms-2 text-dark"></i>
                            <br />
                            <span className="fs-8 fw-normal text-secondary">
                              Role-Specific Action Panel
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentRecords.map((vendor, index) => (
                          <tr key={vendor.vendorId}>
                            <td>{indexOfFirstRecord + index + 1}.</td>
                            <td className="lh-sm py-4 text-wrap">
                              <span className="text-dark">Vendor Name</span>{" "}
                              &mdash; {vendor.vendorName}
                              <br />
                              <span className="text-dark">
                                Vendor Type
                              </span>{" "}
                              &mdash; {vendor.vendorType}
                              <br />
                              <span className="text-dark">
                                Contact Person
                              </span>{" "}
                              &mdash; {vendor.contactPerson}
                              <br />
                              <hr className="w-25" />
                              {vendor.contracts?.length ? (
                                vendor.contracts.map((c, i) => (
                                  <div key={i} className="mb-1">
                                    <span className="text-dark">
                                      Contract [{i + 1}]
                                    </span>{" "}
                                    &mdash; {c.contractTitle}
                                    <br />
                                    <span className="text-dark">Type</span>{" "}
                                    &mdash; {c.contractType}
                                    <br />
                                    <span className="text-dark">
                                      Value
                                    </span>{" "}
                                    &mdash; ₹{c.contractValue}
                                  </div>
                                ))
                              ) : (
                                <span className="text-secondary">
                                  No contracts added
                                </span>
                              )}
                            </td>
                            <td>
                              <div className="d-flex flex-column gap-1 width-fit-content">
                                <span
                                  onClick={() => handleEditClick(vendor)}
                                  className="badge bg-success-soft cursor-pointer px-4 rounded-3 btn-py-sm"
                                >
                                  Update
                                </span>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="col-lg-4">
                  <div>
                    <div className="mb-3">
                      <div className="bg-white rounded-pill">
                        <form
                          className="d-flex align-items-center"
                          onSubmit={(e) => e.preventDefault()}
                        >
                          <span className="position-absolute ps-3 search-icon">
                            <i className="bi bi-filter-circle-fill ms-1" />
                          </span>
                          <input
                            type="search"
                            className="form-control ps-7 rounded-3 border-0 rounded-4"
                            placeholder="Filter Data"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </form>
                      </div>
                      <div className="mt-2 ms-4">
                        <nav aria-label="breadcrumb">
                          <ol className="breadcrumb pe-3">
                            <li className="breadcrumb-item">
                              <a href="#">Vendor Management</a>
                            </li>
                            <li
                              className="breadcrumb-item active"
                              aria-current="page"
                            >
                              Contracts & Renewals
                            </li>
                          </ol>
                        </nav>
                      </div>
                    </div>

                    <div className="p-4 bg-white rounded-4">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                          {loading ? (
                            <div
                              className="spinner-border text-dark data-loader-spinner"
                              role="status"
                            ></div>
                          ) : (
                            <img src="/assets/images/folder.svg" alt="folder" />
                          )}
                          <p className="my-0 fw-semibold lh-1 fs-5 text-dark mx-3">
                            Contracts & Renewals
                            <br />
                            <span className="text-secondary fs-6 fw-medium lh-sm">
                              0.1 MB Size
                            </span>
                          </p>
                        </div>
                        <span
                          onClick={handleExportExcel}
                          className="badge bg-pink rounded-3 px-4 py-2 me-1 mt-1 cursor-pointer"
                        >
                          Export
                        </span>
                      </div>

                      <div className="px-4 py-2 mt-3 bg-light rounded-4">
                        <li className="list-group-item px-0">
                          <a
                            className="d-flex align-items-center text-inherit mb-0 justify-content-between"
                            data-bs-toggle="collapse"
                            href="#contractReports"
                            role="button"
                            aria-expanded="false"
                          >
                            <p className="m-0 fw-medium lh-sm text-dark">
                              Download Report
                            </p>
                            <span className="chevron-arrow ms-4">
                              <i className="bi bi-chevron-down fs-4" />
                            </span>
                          </a>
                          <div className="collapse" id="contractReports">
                            <div className="py-3">
                              <div className="rounded-4 d-flex flex-wrap">
                                <span
                                  onClick={handleExportExcel}
                                  className="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1"
                                >
                                  Contracts Report
                                </span>
                              </div>
                            </div>
                          </div>
                        </li>
                      </div>
                    </div>

                    <div className="my-4">
                      <nav>
                        <ul className="pagination justify-content-center mb-0">
                          <li
                            className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                          >
                            <button className="page-link" onClick={prevPage}>
                              <i className="bi bi-chevron-left"></i>
                            </button>
                          </li>
                          {(() => {
                            const pageNumbers = [];
                            pageNumbers.push(1);
                            if (currentPage > 3)
                              pageNumbers.push("left-ellipsis");
                            if (currentPage !== 1 && currentPage !== totalPages)
                              pageNumbers.push(currentPage);
                            if (currentPage < totalPages - 2)
                              pageNumbers.push("right-ellipsis");
                            if (totalPages > 1) pageNumbers.push(totalPages);
                            return pageNumbers.map((page, index) => {
                              if (
                                page === "left-ellipsis" ||
                                page === "right-ellipsis"
                              ) {
                                return (
                                  <li
                                    key={index}
                                    className="page-item disabled"
                                  >
                                    <span className="page-link">...</span>
                                  </li>
                                );
                              }
                              return (
                                <li
                                  key={index}
                                  className={`page-item ${currentPage === page ? "active" : ""}`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() => setCurrentPage(page)}
                                  >
                                    {page}
                                  </button>
                                </li>
                              );
                            });
                          })()}
                          <li
                            className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                          >
                            <button className="page-link" onClick={nextPage}>
                              <i className="bi bi-chevron-right"></i>
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default ContractsRenewals;
